import { useAprioriStore } from '../dal/apriori-store';
import { calculateApriori } from '../domain/apriori-provider';
import { round } from '../../../classifiers/decision-tree/domain/probability';

const AprioriView = () => {

    const params = useAprioriStore(store => store.params);
    const showOnlyStrongRules = useAprioriStore(store => store.showOnlyStrongRules);
    const setShowOnlyStrongRules = useAprioriStore(store => store.setShowOnlyStrongRules);
    const showLift = useAprioriStore(store => store.showLift);
    const setShowLift = useAprioriStore(store => store.setShowLift);

    const results = calculateApriori(params);

    const onShowOnlyStrongRulesChange = () => {
        setShowOnlyStrongRules(!showOnlyStrongRules);
    };

    const onShowLiftChange = () => {
        setShowLift(!showLift);
    };

    return (
        <div className="flex flex-col gap-4 items-start">

            <div className="flex gap-10 justify-between items-center text-sm">
                <div>minSupport: { params.minSupport }%, minConfidence: { params.minConfidence } %</div>
                <label>
                    <span className="mr-2">Only strong rules</span>
                    <input
                        type="checkbox"
                        checked={ showOnlyStrongRules }
                        onChange={ onShowOnlyStrongRulesChange }
                    />
                </label>

                <label>
                    <span className="mr-2">Show lift</span>
                    <input
                        type="checkbox"
                        checked={ showLift }
                        onChange={ onShowLiftChange }
                    />
                </label>
            </div>

            <div className="grid grid-cols-4 gap-6 items-start">

                {
                    results.maps.map((map, i) => {

                        const keys = [...map.keys()];
                        const isC = (i % 2) === 0;

                        return (
                            <>
                                <table key={ `map-${ i }` }>
                                    <thead>
                                    <tr>
                                        <td colSpan={ 2 } className="font-bold border px-4 py-2 text-center bg-slate-100">{ isC ? 'C' : 'L' }{ Math.floor(i / 2) + 1 }</td>
                                    </tr>
                                    <tr>
                                        <th className="font-bold border px-4 py-2 text-center">itemset</th>
                                        <th className="font-bold border px-4 py-2 text-center">support</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        keys.map((key, j) => {

                                            const support = map.get(key);

                                            return (
                                                <tr key={ `map-${ i }-key=${ j }` }>
                                                    <td className="border px-4 py-2 text-center">&#123; { key.split('').join(', ') } &#125;</td>
                                                    {
                                                        isC &&
                                                        <td className="border px-4 py-2 text-center">
                                                            { support.instances } / { support.total } = { round(support.result) }
                                                        </td>
                                                    }

                                                    {
                                                        !isC &&
                                                        <td className="border px-4 py-2 text-center">
                                                            { round(support.result) }
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>

                               <div key={ `ul-map-${ i }` }>
                                   <div className="font-bold">{ isC ? 'C' : 'L' }{ Math.floor(i / 2) + 1 }</div>
                                   <div className="font-bold">itemset - support</div>

                                   <ul className="list-disc ml-4">
                                       {
                                           keys.map((key, j) => {

                                               const support = map.get(key);

                                               return (
                                                   <li key={ `map-${ i }-key=${ j }` }>
                                                       <span>&#123; { key.split('').join(', ') } &#125;</span>
                                                       <span> - </span>
                                                       {
                                                           isC &&
                                                           <span>
                                                            { support.instances } / { support.total } = { round(support.result) }
                                                        </span>
                                                       }

                                                       {
                                                           !isC &&
                                                           <span>
                                                            { round(support.result) }
                                                        </span>
                                                       }
                                                   </li>
                                               )
                                           })
                                       }
                                   </ul>
                               </div>
                            </>
                        )
                    })
                }
            </div>

            <div className="grid grid-cols-3 gap-6 items-start">
                <div className="border p-4 bg-sky-50 border-sky-200">
                    <strong className="mb-4">קבוצות תדירות:</strong>
                    {
                        results.frequencyGroups.map((frequencyGroup, i) => {
                            return (
                                <div key={ `group-${ i }` }>
                                    &#123; { frequencyGroup.split('').join(', ') } &#125;
                                </div>
                            )
                        })
                    }
                </div>

                {
                    !showOnlyStrongRules &&
                    <table className="bg-white mb-10">
                        <thead>
                        <tr>
                            <td className="font-bold border px-4 py-2 text-center bg-slate-100">&nbsp;</td>
                            <th className="font-bold border px-4 py-2 text-center bg-slate-100">חוק הקשר</th>
                            <th className="font-bold border px-4 py-2 text-center bg-slate-100">confidence</th>
                            <th className="font-bold border px-4 py-2 text-center bg-slate-100">חזק?</th>
                        </tr>
                        </thead>

                        <tbody>
                        {
                            results.associationRules.map((associationRule, i) => {
                                return (
                                    <tr key={ `association-rule-${ i }` }>
                                        <td className="border px-4 py-2 text-center bg-slate-100">{ i + 1 }</td>
                                        <td className="border px-4 py-2 text-center">
                                            { associationRule.rule[0] } --&gt; { associationRule.rule[1] }
                                        </td>
                                        <td className="border px-4 py-2 text-center">
                                            { associationRule.confidence.topSupport.result } / { associationRule.confidence.bottomSupport.result } = { round(associationRule.confidence.result) }
                                        </td>
                                        <td className="border px-4 py-2 text-center">
                                            { associationRule.isStrong ? '✅' : '' }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                }

                <table className="bg-white mb-10">
                    <thead>
                    <tr>
                        <td className="font-bold border px-4 py-2 text-center bg-slate-100">&nbsp;</td>
                        <th className="font-bold border px-4 py-2 text-center bg-slate-100">חוקי הקשר חזקים</th>
                        <th className="font-bold border px-4 py-2 text-center bg-slate-100">confidence</th>
                    </tr>
                    </thead>

                    <tbody>
                    {
                        results.associationRules.filter(rule => rule.isStrong).map((associationRule, i) => {
                            return (
                                <tr key={ `strong-association-rule-${ i }` }>
                                    <td className="border px-4 py-2 text-center bg-slate-100">{ i + 1 }</td>
                                    <td className="border px-4 py-2 text-center">
                                        { associationRule.rule[0] } --&gt; { associationRule.rule[1] }
                                    </td>
                                    <td className="border px-4 py-2 text-center">
                                        { associationRule.confidence.topSupport.result } / { associationRule.confidence.bottomSupport.result } = { associationRule.confidence.result }
                                    </td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>

                {
                    showLift &&
                    <table className="bg-white mb-10">
                        <thead>
                        <tr>
                            <td className="font-bold border px-4 py-2 text-center bg-slate-100">&nbsp;</td>
                            <th className="font-bold border px-4 py-2 text-center bg-slate-100">חוק הקשר</th>
                            <th className="font-bold border px-4 py-2 text-center bg-slate-100">lift</th>
                        </tr>
                        </thead>

                        <tbody>
                        {
                            results.associationRules.map((associationRule, i) => {
                                return (
                                    <tr key={ `association-rule-${ i }` }>
                                        <td className="border px-4 py-2 text-center bg-slate-100">{ i + 1 }</td>
                                        <td className="border px-4 py-2 text-center">
                                            { associationRule.rule[0] } --&gt; { associationRule.rule[1] }
                                        </td>
                                        <td className="border px-4 py-2 text-center">
                                            { associationRule.lift.top.result } / ({ associationRule.lift.bottom1.result } * { associationRule.lift.bottom2.result }) = { round(associationRule.lift.result) }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    )
};

export default AprioriView;